import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { ColorPickerModule } from '../../../../components/color-picker/color-picker.module';
import { ItemModule } from '../../../../components/item/item.module';
import { TranslateModule } from '../../../../components/translate/translate.module';
import { TranslatorModule } from '../../../../components/translator/translator.module';
import { DaterModule } from '../../../../pipes/dater/dater.module';
import { MergedCase } from '../merged-case.type';

@Component({
  selector: 'apex-merged-cases-list-item',
  templateUrl: './merged-cases-list-item.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TranslatorModule,
    DaterModule,
    ItemModule,
    MatDividerModule,
    ColorPickerModule,
    FormsModule,
  ],
})
export class MergedCasesListItemComponent {
  @Input() mergedCase?: MergedCase;
}
